import React, { useContext } from 'react';
import { Layout, Content, MainContent, MainWrapper } from './styles';
import { Header, Sidebar } from '../../index';
import { AuthContext } from '../../../helpers/context_manager/AuthContext';
import { RouterManager } from '../../../helpers';
import { SidebarProvider } from '../Sidebar/SidebarContext';

export const Template: React.FC = () => {
  const context = useContext(AuthContext);
  return (
    <SidebarProvider>
      <Layout>
        {context?.authToken && <Sidebar />}
        <Content>
          <Header />
          <MainContent>
            <MainWrapper>
              <RouterManager />
            </MainWrapper>
          </MainContent>
        </Content>
      </Layout>
    </SidebarProvider>
  );
};
